/* tslint:disable */
//  This file was automatically generated and should not be edited.

export enum VendorVideoLinkType {
  VIMEO = "VIMEO",
  YOUTUBE = "YOUTUBE",
}